import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { firstValueFrom, tap } from 'rxjs';

/**
 * The user client is used to fetch user information from the CDF quarkus backend.
 * The access token is automatically injected by the auth-interceptor as header.
 * The backend uses WEN's userinfo endpoint to return relevant information for the frontend.
 */
@Injectable({
  providedIn: 'root',
})
export class WenClient {
  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);

  getJwks(): Promise<object> {
    const url = 'wen/jwks';
    this.logger.info(`#CDFTF0026 Fetching jwks ${url}`);
    return firstValueFrom(
      this.http.get<object>(url).pipe(
        tap({
          error: (error) => this.logger.error('#CDFTF0027 Unable to fetch jwks', error),
        }),
      ),
    );
  }
}
